'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reactImmutableProptypes2.default.mapContains({
  remaining: _react.PropTypes.number,
  total: _react.PropTypes.number,
  type: _react.PropTypes.string
});


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/bc-prop-types/lib/components/borrowingQuotaShape.js
// module id = 294
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14